import React from 'react';
import GenericTermsPage from '../../../components/GenericTermsPage';

const APP_NAME = 'Random Number Generator Pro';
const LAST_UPDATED_DATE = 'May 2025';

const TERMS_OF_SERVICE_CONTENT = `
1. Acceptance of Terms
By using the Random Number Generator Pro app ("App"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use the App.

2. Use License
Permission is granted to temporarily download one copy of the App for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title.
This license does not allow you to:
- Modify or copy the materials;
- Use the materials for any commercial purpose, or for any public display (commercial or non-commercial);
- Attempt to decompile or reverse engineer any software contained in the App;
- Remove any copyright or other proprietary notations from the materials; or
- Transfer the materials to another person or "mirror" the materials on any other server.
This license shall automatically terminate if you violate any of these restrictions and may be terminated by CodeMates at any time.
Premium Features: Certain features within the App ("Premium Features") require a valid, active subscription purchased through your device's app store (e.g., Apple App Store, Google Play Store). Access to Premium Features is contingent upon maintaining this subscription. Subscriptions are non-refundable in any circumstances, unless required by applicable law or the policies of the respective app store. Refunds, if any, are handled exclusively by the respective app store according to their policies.

3. Disclaimer
Random numbers generated by the App use pseudo-random algorithms. While suitable for most casual purposes, they are not cryptographically secure and should not be used for applications requiring true randomness or high security.
The materials within the App are provided on an 'as is' basis. CodeMates makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.

4. Limitations
In no event shall CodeMates or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on the App, even if CodeMates or a CodeMates authorized representative has been notified orally or in writing of the possibility of such damage.

5. Accuracy of Materials
The materials appearing in the App could include technical, typographical, or photographic errors. CodeMates does not warrant that any of the materials on the App are accurate, complete or current. CodeMates may make changes to the materials contained in the App at any time without notice. However CodeMates does not make any commitment to update the materials.

6. Links
CodeMates has not reviewed all of the sites linked to its App (if any) and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by CodeMates of the site. Use of any such linked website is at the user's own risk.

7. Modifications
CodeMates may revise these Terms of Service for its App at any time without notice. By using this App you are agreeing to be bound by the then current version of these Terms of Service.

8. Governing Law
Any legal suit, action, or proceeding arising out of, or related to, these Terms or the App shall be instituted exclusively in the courts of Hong Kong, although we retain the right to bring any suit, action, or proceeding against you for breach of these Terms in your country of residence or any other relevant country. You waive any and all objections to the exercise of jurisdiction over you by such courts and to venue in such courts.

9. Contact Us
If you have any questions about these Terms, please contact us at <a href="mailto:support.rng@codemates.app" style="color:#007bff;text-decoration:none;">support.rng@codemates.app</a>.
`;

function RandomNumberGeneratorTermsPage() {
  return (
    <GenericTermsPage
      appName={APP_NAME}
      lastUpdatedDate={LAST_UPDATED_DATE}
      termsContent={TERMS_OF_SERVICE_CONTENT}
    />
  );
}

export default RandomNumberGeneratorTermsPage;
